import { FC, useMemo, useState } from "react";
import { Asset, MsgExec } from "rujira.js";
import { DenomInput, i18n, Toggle } from "rujira.ui";
import {
  BalanceCompact,
  usePreloadedBalance,
} from "../../common/components/Balance";
import {
  MsgProvider,
  TxBalanceAccountButton,
} from "../../common/components/TxButton";
import { useAccounts } from "../../services/accounts";

export const GhostVaultDeposit: FC<{
  asset: Asset;
  address: string;
}> = ({ address, asset }) => {
  const { selected } = useAccounts();

  const [amount, setAmount] = useState(0n);
  const [accept, setAccept] = useState(false);
  const { balance, account } = usePreloadedBalance();

  const msgDepositAsset = useMemo(() => {
    if (!accept) return null;
    if (!account) return null;
    return selected && amount
      ? new MsgExec(
          { address: account.address, network: "THOR" },
          account.asset,
          amount,
          address,
          { deposit: {} }
        )
      : null;
  }, [accept, amount, selected]);

  return (
    <MsgProvider msg={msgDepositAsset}>
      <div className="card h-full p-3">
        <i18n.h3 className="fs-18 lh-22 fw-500 color-white">
          Deposit Asset
        </i18n.h3>
        <DenomInput
          symbol={asset.metadata.symbol}
          className="mt-2"
          amount={amount}
          decimals={asset.metadata.decimals}
          onChangeAmount={setAmount}
          max={balance?.balance || 0n}
        />
        <BalanceCompact
          className="mt-1"
          onClick={(v) => setAmount(v.balance)}
        />

        <div className="flex wrap ai-s mt-1">
          <Toggle
            checked={accept}
            onChange={(e) => {
              setAccept(e.currentTarget.checked);
            }}
            className="mt-2 toggle--small ai-c">
            <span className="toggle__label">
              I accept the{" "}
              <a
                href="/tou"
                target="_blank"
                className="color-white hover-primary1">
                terms of use
              </a>
            </span>
          </Toggle>
          <div className="mt-1 block ml-a text-right">
            <TxBalanceAccountButton
              hideSimulation
              label={`Lend ${asset.metadata.symbol}`}
              required={{ asset, amount }}
            />
          </div>
        </div>
      </div>
    </MsgProvider>
  );
};
